module.exports = require("./mt-MT.js");